import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _61550527 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _405383de = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _706f58f0 = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _14beec29 = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _c512cac6 = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _849ea67e = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _6ddc57da = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _558c9cda = () => interopDefault(import('../src/pages/sessions/branu-logout.vue' /* webpackChunkName: "pages/sessions/branu-logout" */))
const _687a0a40 = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _1110d1ba = () => interopDefault(import('../src/pages/sessions/callback-with-branu-user.vue' /* webpackChunkName: "pages/sessions/callback-with-branu-user" */))
const _3fe8aad4 = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _e68e8a22 = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _7f9d7820 = () => interopDefault(import('../src/pages/companies/_company_id/attendance-summary.vue' /* webpackChunkName: "pages/companies/_company_id/attendance-summary" */))
const _0f525211 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _413f0422 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _31ccee17 = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _2d602d28 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _e49fb576 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _33ffc167 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _3a7f515d = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _29d59b5b = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _3e3ad82a = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _2e292f28 = () => interopDefault(import('../src/pages/companies/_company_id/projects.vue' /* webpackChunkName: "pages/companies/_company_id/projects" */))
const _6fe090aa = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _3740b5f5 = () => interopDefault(import('../src/pages/companies/_company_id/projects/calendar.vue' /* webpackChunkName: "pages/companies/_company_id/projects/calendar" */))
const _61b8cdc1 = () => interopDefault(import('../src/pages/companies/_company_id/projects/gantt-chart/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/gantt-chart/index" */))
const _30a37db9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _27ebb9ca = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/index" */))
const _c7e822cc = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/devices-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/devices-allocation/index" */))
const _84095082 = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/member-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/member-allocation/index" */))
const _1ceda8d3 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _88c1f5d4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _eb0616d0 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _025bf081 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _d89c9202 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _5094ad3d = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _8abcadd0 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/ledger/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/ledger/index" */))
const _3e68d306 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _09fc6674 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/index" */))
const _3f8ac7c6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _f24dd428 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _8a6ec9b4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _f4f4fa2c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _73a650ee = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _2bb4fbfd = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _4d33f40f = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _00f49805 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _21249eb6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/select-daily-reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/select-daily-reports" */))
const _01bb2cf7 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _29e230bc = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _7caa15e4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _38b3a8b8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _211983d9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _00e39325 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _af137774 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _37b71787 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _e7141d66 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _66693e46 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _05e08d3c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _74ec5980 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/form.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/form" */))
const _b9a63c08 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/preview" */))
const _42ca62c4 = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _61fb25dc = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _46ecb4dc = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _2f641c13 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/index" */))
const _d8e230bc = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _e28eca56 = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _61bd0d8a = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/analytics/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/analytics/index" */))
const _6c5524e7 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _972708a2 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _508c17f3 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/_member_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/_member_id/index" */))
const _a26974f6 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _4d89c99d = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _70d374ce = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/ai_pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/ai_pdf" */))
const _5e89f5bd = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _245cfde2 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _741ec513 = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _b32184ca = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _61550527,
      name: "companies"
    }, {
      path: "/logout",
      component: _405383de,
      name: "logout"
    }, {
      path: "/sign_in",
      component: _706f58f0,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _14beec29,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _c512cac6,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _849ea67e,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/user-profile",
      component: _6ddc57da,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/branu-logout",
      component: _558c9cda,
      name: "sessions-branu-logout"
    }, {
      path: "/sessions/callback",
      component: _687a0a40,
      name: "sessions-callback"
    }, {
      path: "/sessions/callback-with-branu-user",
      component: _1110d1ba,
      name: "sessions-callback-with-branu-user"
    }, {
      path: "/sessions/invitation",
      component: _3fe8aad4,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _e68e8a22,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/attendance-summary",
      component: _7f9d7820,
      name: "companies-company_id-attendance-summary"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _0f525211,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _413f0422,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _31ccee17,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _2d602d28,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _e49fb576,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _33ffc167,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _3a7f515d,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _29d59b5b,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _3e3ad82a,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _2e292f28,
      children: [{
        path: "",
        component: _6fe090aa,
        name: "companies-company_id-projects"
      }, {
        path: "calendar",
        component: _3740b5f5,
        name: "companies-company_id-projects-calendar"
      }, {
        path: "gantt-chart",
        component: _61b8cdc1,
        name: "companies-company_id-projects-gantt-chart"
      }, {
        path: "new",
        component: _30a37db9,
        name: "companies-company_id-projects-new"
      }, {
        path: "resource-allocation",
        component: _27ebb9ca,
        name: "companies-company_id-projects-resource-allocation"
      }, {
        path: "resource-allocation/devices-allocation",
        component: _c7e822cc,
        name: "companies-company_id-projects-resource-allocation-devices-allocation"
      }, {
        path: "resource-allocation/member-allocation",
        component: _84095082,
        name: "companies-company_id-projects-resource-allocation-member-allocation"
      }, {
        path: ":id",
        component: _1ceda8d3,
        children: [{
          path: "",
          component: _88c1f5d4,
          name: "companies-company_id-projects-id"
        }, {
          path: "attendance",
          component: _eb0616d0,
          name: "companies-company_id-projects-id-attendance"
        }, {
          path: "board_posts",
          component: _025bf081,
          name: "companies-company_id-projects-id-board_posts"
        }, {
          path: "card",
          component: _d89c9202,
          name: "companies-company_id-projects-id-card"
        }, {
          path: "detail",
          component: _5094ad3d,
          name: "companies-company_id-projects-id-detail"
        }, {
          path: "ledger",
          component: _8abcadd0,
          name: "companies-company_id-projects-id-ledger"
        }, {
          path: "member",
          component: _3e68d306,
          name: "companies-company_id-projects-id-member"
        }, {
          path: "reports",
          component: _09fc6674,
          name: "companies-company_id-projects-id-reports"
        }, {
          path: "schedule",
          component: _3f8ac7c6,
          name: "companies-company_id-projects-id-schedule"
        }, {
          path: "attendance/summary",
          component: _f24dd428,
          name: "companies-company_id-projects-id-attendance-summary"
        }, {
          path: "attendance/user-list",
          component: _8a6ec9b4,
          name: "companies-company_id-projects-id-attendance-user-list"
        }, {
          path: "attendance/user-records",
          component: _f4f4fa2c,
          name: "companies-company_id-projects-id-attendance-user-records"
        }, {
          path: "attendance/utils",
          component: _73a650ee,
          name: "companies-company_id-projects-id-attendance-utils",
          children: [{
            path: "user-list",
            component: _2bb4fbfd,
            name: "companies-company_id-projects-id-attendance-utils-user-list"
          }]
        }, {
          path: "board_posts/new",
          component: _4d33f40f,
          name: "companies-company_id-projects-id-board_posts-new"
        }, {
          path: "board_posts/posts",
          component: _00f49805,
          name: "companies-company_id-projects-id-board_posts-posts"
        }, {
          path: "reports/select-daily-reports",
          component: _21249eb6,
          name: "companies-company_id-projects-id-reports-select-daily-reports"
        }, {
          path: "schedule/fullscreen",
          component: _01bb2cf7,
          name: "companies-company_id-projects-id-schedule-fullscreen"
        }, {
          path: "schedule/preview",
          component: _29e230bc,
          name: "companies-company_id-projects-id-schedule-preview"
        }, {
          path: "schedule/print",
          component: _7caa15e4,
          name: "companies-company_id-projects-id-schedule-print"
        }, {
          path: "schedule/view",
          component: _38b3a8b8,
          name: "companies-company_id-projects-id-schedule-view"
        }, {
          path: "schedule/view/fullscreen",
          component: _211983d9,
          name: "companies-company_id-projects-id-schedule-view-fullscreen"
        }, {
          path: "board_posts/:board_id",
          component: _00e39325,
          name: "companies-company_id-projects-id-board_posts-board_id"
        }, {
          path: "files/:file_id",
          component: _af137774,
          name: "companies-company_id-projects-id-files-file_id"
        }, {
          path: "board_posts/:board_id/edit",
          component: _37b71787,
          name: "companies-company_id-projects-id-board_posts-board_id-edit"
        }, {
          path: "board_posts/:board_id/files",
          component: _e7141d66,
          name: "companies-company_id-projects-id-board_posts-board_id-files"
        }, {
          path: "files/:file_id/edit",
          component: _66693e46,
          name: "companies-company_id-projects-id-files-file_id-edit"
        }, {
          path: "files/:file_id/preview",
          component: _05e08d3c,
          name: "companies-company_id-projects-id-files-file_id-preview"
        }, {
          path: "reports/:report_id/form",
          component: _74ec5980,
          name: "companies-company_id-projects-id-reports-report_id-form"
        }, {
          path: "reports/:report_id/preview",
          component: _b9a63c08,
          name: "companies-company_id-projects-id-reports-report_id-preview"
        }]
      }]
    }, {
      path: "/companies/:company_id/reports",
      component: _42ca62c4,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _61fb25dc,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _46ecb4dc,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/skills-register",
      component: _2f641c13,
      name: "companies-company_id-skills-register"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _d8e230bc,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _e28eca56,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/skills-register/analytics",
      component: _61bd0d8a,
      name: "companies-company_id-skills-register-analytics"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _6c5524e7,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _972708a2,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/skills-register/:member_id?",
      component: _508c17f3,
      name: "companies-company_id-skills-register-member_id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _a26974f6,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _4d89c99d,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/ai_pdf",
      component: _70d374ce,
      name: "companies-company_id-reports-id-ai_pdf"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _5e89f5bd,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _245cfde2,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _741ec513,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _b32184ca,
      name: "index"
    }],

    fallback: false
  })
}
